// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('lp', 19, { msid: '5d0ca96e-7e0b-4062-be4f-3a2dedef6d3b' });

$w.onReady(function () {
	// TODO: write your page related code here...

});



/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export async function box1_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	const biEventObject = {
		evid: 703,
		button_name:"Editor X",
		is_valid:true,
		topic:"partners",
		url:wixLocation.url
	};
	await biLogger.log(biEventObject);
	//wixLocation.to("https://users.editorx.com/signin?forceRender=true");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export async function box2_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	const biEventObject = {
		evid: 703,
		button_name:"Wix",
		is_valid:true,
		topic:"partners",
		url:wixLocation.url
	};
	await biLogger.log(biEventObject);
}